import {
  PrimitiveArraySerializer6xcmeltdozbx as PrimitiveArraySerializer,
  PrimitiveArrayBuilder1tzna3i4eqw54 as PrimitiveArrayBuilder,
} from './CollectionSerializers.mjs';
import { Companion_getInstance1genqokpkr3uz as Companion_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  serializer345btyh1f2y1j as serializer,
  serializer1wpgysz06u9ol as serializer_0,
  serializer3x9uckd1deom as serializer_1,
  serializerodflzzf6s3fp as serializer_2,
  serializer2lw83vwvpnyms as serializer_3,
  serializer1hu9wv9at41ww as serializer_4,
  serializer3ikrxnm8b29d6 as serializer_5,
  serializer1tw0a8bv7lkga as serializer_6,
  serializer1q7c5q67ysppr as serializer_7,
  serializer1r0h5yakm679b as serializer_8,
  serializer36584sjyg5661 as serializer_9,
  serializer3u3hsxnenk49x as serializer_10,
} from '../builtins/BuiltinSerializers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  isCharArray21auq5hbrg68m as isCharArray,
  isDoubleArray1wyh4nyf7pjxn as isDoubleArray,
  isFloatArrayjjscnqphw92j as isFloatArray,
  isIntArrayeijsubfngq38 as isIntArray,
  isShortArraywz30zxwtqi8h as isShortArray,
  isByteArray4nnzfn1x4o3w as isByteArray,
  isBooleanArray35llghle4c6w1 as isBooleanArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  copyOf2p23ljc5f5ea3 as copyOf,
  copyOfgossjg6lh6js as copyOf_0,
  copyOfq9pcgcgbldck as copyOf_1,
  copyOf9mbsebmgnw4t as copyOf_2,
  copyOf3rutauicler23 as copyOf_3,
  copyOf39s58md6y6rn6 as copyOf_4,
  copyOfwy6h3t5vzqpl as copyOf_5,
  copyOf37mht4mx7mjgh as copyOf_6,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  DoubleCompanionObject_instance43opzxl97v4p as DoubleCompanionObject_instance,
  FloatCompanionObject_instanceokgc3apyetrg as FloatCompanionObject_instance,
  IntCompanionObject_instance3g0jtywew2pgh as IntCompanionObject_instance,
  ShortCompanionObject_instance33mqksfmw0mrs as ShortCompanionObject_instance,
  ByteCompanionObject_instance1r92wkzdy7g72 as ByteCompanionObject_instance,
  BooleanCompanionObject_instance2tls5h1cufcrh as BooleanCompanionObject_instance,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { Companion_instancel8ig9z4updma as Companion_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Primitives.mjs';
import { isLongArray21mxwb8b0y2ii as isLongArray } from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  Companion_getInstance11ies3wlxhmd7 as Companion_getInstance_0,
  _ULong___init__impl__c78o9k1vasxel72m2l4 as _ULong___init__impl__c78o9k,
  _ULong___get_data__impl__fggpzbbo8lz7f8fnfy as _ULong___get_data__impl__fggpzb,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import {
  _ULongArray___get_size__impl__ju6dtr202zbq0mnq27s as _ULongArray___get_size__impl__ju6dtr,
  ULongArray3nd0d80mdwjj8 as ULongArray,
  _ULongArray___get_storage__impl__28e64jr3nto0sn44go as _ULongArray___get_storage__impl__28e64j,
  _ULongArray___init__impl__twm1l32hx2p2tkf1yk as _ULongArray___init__impl__twm1l3,
  ULongArray__get_impl_pr71q9399vaqruv2nhv as ULongArray__get_impl_pr71q9,
  _ULongArray___init__impl__twm1l39g76mgefo3i0 as _ULongArray___init__impl__twm1l3_0,
  ULongArray__set_impl_z19mvhkfwz87ruujvs as ULongArray__set_impl_z19mvh,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ULongArray.mjs';
import {
  Companion_getInstance1crempiiqys0g as Companion_getInstance_1,
  _UInt___init__impl__l7qpdl5ip6p2ldulrs as _UInt___init__impl__l7qpdl,
  _UInt___get_data__impl__f0vqqw30ojw38w2y6td as _UInt___get_data__impl__f0vqqw,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import {
  _UIntArray___get_size__impl__r6l8ci363v3neofz6lm as _UIntArray___get_size__impl__r6l8ci,
  UIntArrayrp6cv44n5v4y as UIntArray,
  _UIntArray___get_storage__impl__92a0v011llee1eit29k as _UIntArray___get_storage__impl__92a0v0,
  _UIntArray___init__impl__ghjpc61ipdjtpvetv4q as _UIntArray___init__impl__ghjpc6,
  UIntArray__get_impl_gp5kza9j53w29hfyue as UIntArray__get_impl_gp5kza,
  _UIntArray___init__impl__ghjpc62fnuksf3r5j9k as _UIntArray___init__impl__ghjpc6_0,
  UIntArray__set_impl_7f2zu2tazd6l4qyq51 as UIntArray__set_impl_7f2zu2,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UIntArray.mjs';
import {
  Companion_getInstance1foc7f9q9rk1s as Companion_getInstance_2,
  _UShort___init__impl__jigrne1e3nphhrejdd8 as _UShort___init__impl__jigrne,
  _UShort___get_data__impl__g02451raj6q6epxg1b as _UShort___get_data__impl__g0245,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
import {
  _UShortArray___get_size__impl__jqto1b2ufu97m66fe6o as _UShortArray___get_size__impl__jqto1b,
  UShortArray11avpmknxdgvv as UShortArray,
  _UShortArray___get_storage__impl__t2jpv5vwyttef17wd6 as _UShortArray___get_storage__impl__t2jpv5,
  _UShortArray___init__impl__9b26ef35x6jp7uuoumr as _UShortArray___init__impl__9b26ef,
  UShortArray__get_impl_fnbhmx2opdoe19gpa9f as UShortArray__get_impl_fnbhmx,
  _UShortArray___init__impl__9b26eftay922a1mq7k as _UShortArray___init__impl__9b26ef_0,
  UShortArray__set_impl_6d8whp2ks3cfavbrzax as UShortArray__set_impl_6d8whp,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UShortArray.mjs';
import {
  Companion_getInstanceb1xi7131i8df as Companion_getInstance_3,
  _UByte___init__impl__g9hnc49zztd2brjj2m as _UByte___init__impl__g9hnc4,
  _UByte___get_data__impl__jof9qr100nrznmlnqj as _UByte___get_data__impl__jof9qr,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import {
  _UByteArray___get_size__impl__h6pkdvvbgvcqs6floa as _UByteArray___get_size__impl__h6pkdv,
  UByteArray2qu4d6gwssdf9 as UByteArray,
  _UByteArray___get_storage__impl__d4kctt1j62rlq0o4l4a as _UByteArray___get_storage__impl__d4kctt,
  _UByteArray___init__impl__ip4y9n1laeec2dn8xeh as _UByteArray___init__impl__ip4y9n,
  UByteArray__get_impl_t5f3hv2p3mnhavewinq as UByteArray__get_impl_t5f3hv,
  _UByteArray___init__impl__ip4y9n1cvrvnisuepir as _UByteArray___init__impl__ip4y9n_0,
  UByteArray__set_impl_jvcicn2pkpqr7t9ajj8 as UByteArray__set_impl_jvcicn,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UByteArray.mjs';
import {
  charArray2ujmm1qusno00 as charArray,
  booleanArray2jdug9b51huk7 as booleanArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CharArraySerializerClass;
function CharArraySerializer() {
  if (CharArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        CharArraySerializer_instance = null;
        super(serializer(Companion_getInstance()));
        CharArraySerializer_instance = this;
      }
      l20(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      c1w(_this__u8e3s4) {
        return this.l20((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      m20(_this__u8e3s4, expectedSize) {
        if (expectedSize === _this__u8e3s4.length)
          return CharArrayBuilder().p20(_this__u8e3s4);
        return CharArrayBuilder().q20(copyOf(_this__u8e3s4, expectedSize), _this__u8e3s4.length);
      }
      b1v(_this__u8e3s4, expectedSize) {
        return this.m20((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE(), expectedSize);
      }
      j1x(size) {
        return CharArrayBuilder().r20(size);
      }
      i1x() {
        return CharArrayBuilder().s20();
      }
      t20(decoder, index, builder, checkIndex) {
        builder.u20(decoder.b1s(this.b1x_1, index));
      }
      k1v(decoder, index, builder, checkIndex) {
        return this.t20(decoder, index, builder instanceof CharArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      k1x(decoder, index, builder, checkIndex) {
        return this.t20(decoder, index, builder instanceof CharArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      v20(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.h1t(this.b1x_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      l1x(encoder, content, size) {
        return this.v20(encoder, (!(content == null) ? isCharArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'CharArraySerializer', VOID, VOID, [KSerializer()]);
    CharArraySerializerClass = $;
  }
  return CharArraySerializerClass;
}
var CharArraySerializer_instance;
function CharArraySerializer_getInstance() {
  if (CharArraySerializer_instance === VOID)
    new (CharArraySerializer())();
  return CharArraySerializer_instance;
}
var DoubleArraySerializerClass;
function DoubleArraySerializer() {
  if (DoubleArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        DoubleArraySerializer_instance = null;
        super(serializer_0(DoubleCompanionObject_instance));
        DoubleArraySerializer_instance = this;
      }
      y20(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      c1w(_this__u8e3s4) {
        return this.y20((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      z20(_this__u8e3s4, expectedSize) {
        if (expectedSize === _this__u8e3s4.length)
          return DoubleArrayBuilder().c21(_this__u8e3s4);
        return DoubleArrayBuilder().d21(copyOf_0(_this__u8e3s4, expectedSize), _this__u8e3s4.length);
      }
      b1v(_this__u8e3s4, expectedSize) {
        return this.z20((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE(), expectedSize);
      }
      j1x(size) {
        return DoubleArrayBuilder().e21(size);
      }
      i1x() {
        return DoubleArrayBuilder().f21();
      }
      g21(decoder, index, builder, checkIndex) {
        builder.h21(decoder.a1s(this.b1x_1, index));
      }
      k1v(decoder, index, builder, checkIndex) {
        return this.g21(decoder, index, builder instanceof DoubleArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      k1x(decoder, index, builder, checkIndex) {
        return this.g21(decoder, index, builder instanceof DoubleArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      i21(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.g1t(this.b1x_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      l1x(encoder, content, size) {
        return this.i21(encoder, (!(content == null) ? isDoubleArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'DoubleArraySerializer', VOID, VOID, [KSerializer()]);
    DoubleArraySerializerClass = $;
  }
  return DoubleArraySerializerClass;
}
var DoubleArraySerializer_instance;
function DoubleArraySerializer_getInstance() {
  if (DoubleArraySerializer_instance === VOID)
    new (DoubleArraySerializer())();
  return DoubleArraySerializer_instance;
}
var FloatArraySerializerClass;
function FloatArraySerializer() {
  if (FloatArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        FloatArraySerializer_instance = null;
        super(serializer_1(FloatCompanionObject_instance));
        FloatArraySerializer_instance = this;
      }
      l21(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      c1w(_this__u8e3s4) {
        return this.l21((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      m21(_this__u8e3s4, expectedSize) {
        if (expectedSize === _this__u8e3s4.length)
          return FloatArrayBuilder().p21(_this__u8e3s4);
        return FloatArrayBuilder().q21(copyOf_1(_this__u8e3s4, expectedSize), _this__u8e3s4.length);
      }
      b1v(_this__u8e3s4, expectedSize) {
        return this.m21((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE(), expectedSize);
      }
      j1x(size) {
        return FloatArrayBuilder().r21(size);
      }
      i1x() {
        return FloatArrayBuilder().s21();
      }
      t21(decoder, index, builder, checkIndex) {
        builder.u21(decoder.z1r(this.b1x_1, index));
      }
      k1v(decoder, index, builder, checkIndex) {
        return this.t21(decoder, index, builder instanceof FloatArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      k1x(decoder, index, builder, checkIndex) {
        return this.t21(decoder, index, builder instanceof FloatArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      v21(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.f1t(this.b1x_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      l1x(encoder, content, size) {
        return this.v21(encoder, (!(content == null) ? isFloatArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'FloatArraySerializer', VOID, VOID, [KSerializer()]);
    FloatArraySerializerClass = $;
  }
  return FloatArraySerializerClass;
}
var FloatArraySerializer_instance;
function FloatArraySerializer_getInstance() {
  if (FloatArraySerializer_instance === VOID)
    new (FloatArraySerializer())();
  return FloatArraySerializer_instance;
}
var LongArraySerializerClass;
function LongArraySerializer() {
  if (LongArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        LongArraySerializer_instance = null;
        super(serializer_2(Companion_instance));
        LongArraySerializer_instance = this;
      }
      y21(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      c1w(_this__u8e3s4) {
        return this.y21((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      z21(_this__u8e3s4, expectedSize) {
        if (expectedSize === _this__u8e3s4.length)
          return LongArrayBuilder().c22(_this__u8e3s4);
        return LongArrayBuilder().d22(copyOf_2(_this__u8e3s4, expectedSize), _this__u8e3s4.length);
      }
      b1v(_this__u8e3s4, expectedSize) {
        return this.z21((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE(), expectedSize);
      }
      j1x(size) {
        return LongArrayBuilder().e22(size);
      }
      i1x() {
        return LongArrayBuilder().f22();
      }
      g22(decoder, index, builder, checkIndex) {
        builder.h22(decoder.y1r(this.b1x_1, index));
      }
      k1v(decoder, index, builder, checkIndex) {
        return this.g22(decoder, index, builder instanceof LongArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      k1x(decoder, index, builder, checkIndex) {
        return this.g22(decoder, index, builder instanceof LongArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      i22(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.e1t(this.b1x_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      l1x(encoder, content, size) {
        return this.i22(encoder, (!(content == null) ? isLongArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'LongArraySerializer', VOID, VOID, [KSerializer()]);
    LongArraySerializerClass = $;
  }
  return LongArraySerializerClass;
}
var LongArraySerializer_instance;
function LongArraySerializer_getInstance() {
  if (LongArraySerializer_instance === VOID)
    new (LongArraySerializer())();
  return LongArraySerializer_instance;
}
var ULongArraySerializerClass;
function ULongArraySerializer() {
  if (ULongArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        ULongArraySerializer_instance = null;
        super(serializer_3(Companion_getInstance_0()));
        ULongArraySerializer_instance = this;
      }
      l22(_this__u8e3s4) {
        return _ULongArray___get_size__impl__ju6dtr(_this__u8e3s4);
      }
      c1w(_this__u8e3s4) {
        return this.l22(_this__u8e3s4 instanceof ULongArray() ? _this__u8e3s4.wv_1 : THROW_CCE());
      }
      m22(_this__u8e3s4, expectedSize) {
        if (expectedSize === _ULongArray___get_size__impl__ju6dtr(_this__u8e3s4))
          return ULongArrayBuilder().p22(_this__u8e3s4);
        // Inline function 'kotlin.collections.copyOf' call
        var tmp$ret$0 = _ULongArray___init__impl__twm1l3(copyOf_2(_ULongArray___get_storage__impl__28e64j(_this__u8e3s4), expectedSize));
        return ULongArrayBuilder().q22(tmp$ret$0, _ULongArray___get_size__impl__ju6dtr(_this__u8e3s4));
      }
      b1v(_this__u8e3s4, expectedSize) {
        return this.m22(_this__u8e3s4 instanceof ULongArray() ? _this__u8e3s4.wv_1 : THROW_CCE(), expectedSize);
      }
      j1x(size) {
        return ULongArrayBuilder().r22(size);
      }
      i1x() {
        return ULongArrayBuilder().s22();
      }
      t22(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toULong' call
        var this_0 = decoder.d1s(this.b1x_1, index).j1r();
        var tmp$ret$0 = _ULong___init__impl__c78o9k(this_0);
        builder.u22(tmp$ret$0);
      }
      k1v(decoder, index, builder, checkIndex) {
        return this.t22(decoder, index, builder instanceof ULongArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      k1x(decoder, index, builder, checkIndex) {
        return this.t22(decoder, index, builder instanceof ULongArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      v22(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.j1t(this.b1x_1, i);
            // Inline function 'kotlin.ULong.toLong' call
            var this_0 = ULongArray__get_impl_pr71q9(content, i);
            var tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
            tmp.t1s(tmp$ret$0);
          }
           while (inductionVariable < size);
      }
      l1x(encoder, content, size) {
        return this.v22(encoder, content instanceof ULongArray() ? content.wv_1 : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'ULongArraySerializer', VOID, VOID, [KSerializer()]);
    ULongArraySerializerClass = $;
  }
  return ULongArraySerializerClass;
}
var ULongArraySerializer_instance;
function ULongArraySerializer_getInstance() {
  if (ULongArraySerializer_instance === VOID)
    new (ULongArraySerializer())();
  return ULongArraySerializer_instance;
}
var IntArraySerializerClass;
function IntArraySerializer() {
  if (IntArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        IntArraySerializer_instance = null;
        super(serializer_4(IntCompanionObject_instance));
        IntArraySerializer_instance = this;
      }
      y22(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      c1w(_this__u8e3s4) {
        return this.y22((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      z22(_this__u8e3s4, expectedSize) {
        if (expectedSize === _this__u8e3s4.length)
          return IntArrayBuilder().c23(_this__u8e3s4);
        return IntArrayBuilder().d23(copyOf_3(_this__u8e3s4, expectedSize), _this__u8e3s4.length);
      }
      b1v(_this__u8e3s4, expectedSize) {
        return this.z22((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE(), expectedSize);
      }
      j1x(size) {
        return IntArrayBuilder().e23(size);
      }
      i1x() {
        return IntArrayBuilder().f23();
      }
      g23(decoder, index, builder, checkIndex) {
        builder.h23(decoder.x1r(this.b1x_1, index));
      }
      k1v(decoder, index, builder, checkIndex) {
        return this.g23(decoder, index, builder instanceof IntArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      k1x(decoder, index, builder, checkIndex) {
        return this.g23(decoder, index, builder instanceof IntArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      i23(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.d1t(this.b1x_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      l1x(encoder, content, size) {
        return this.i23(encoder, (!(content == null) ? isIntArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'IntArraySerializer', VOID, VOID, [KSerializer()]);
    IntArraySerializerClass = $;
  }
  return IntArraySerializerClass;
}
var IntArraySerializer_instance;
function IntArraySerializer_getInstance() {
  if (IntArraySerializer_instance === VOID)
    new (IntArraySerializer())();
  return IntArraySerializer_instance;
}
var UIntArraySerializerClass;
function UIntArraySerializer() {
  if (UIntArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        UIntArraySerializer_instance = null;
        super(serializer_5(Companion_getInstance_1()));
        UIntArraySerializer_instance = this;
      }
      l23(_this__u8e3s4) {
        return _UIntArray___get_size__impl__r6l8ci(_this__u8e3s4);
      }
      c1w(_this__u8e3s4) {
        return this.l23(_this__u8e3s4 instanceof UIntArray() ? _this__u8e3s4.lv_1 : THROW_CCE());
      }
      m23(_this__u8e3s4, expectedSize) {
        if (expectedSize === _UIntArray___get_size__impl__r6l8ci(_this__u8e3s4))
          return UIntArrayBuilder().p23(_this__u8e3s4);
        // Inline function 'kotlin.collections.copyOf' call
        var tmp$ret$0 = _UIntArray___init__impl__ghjpc6(copyOf_3(_UIntArray___get_storage__impl__92a0v0(_this__u8e3s4), expectedSize));
        return UIntArrayBuilder().q23(tmp$ret$0, _UIntArray___get_size__impl__r6l8ci(_this__u8e3s4));
      }
      b1v(_this__u8e3s4, expectedSize) {
        return this.m23(_this__u8e3s4 instanceof UIntArray() ? _this__u8e3s4.lv_1 : THROW_CCE(), expectedSize);
      }
      j1x(size) {
        return UIntArrayBuilder().r23(size);
      }
      i1x() {
        return UIntArrayBuilder().s23();
      }
      t23(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toUInt' call
        var this_0 = decoder.d1s(this.b1x_1, index).i1r();
        var tmp$ret$0 = _UInt___init__impl__l7qpdl(this_0);
        builder.u23(tmp$ret$0);
      }
      k1v(decoder, index, builder, checkIndex) {
        return this.t23(decoder, index, builder instanceof UIntArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      k1x(decoder, index, builder, checkIndex) {
        return this.t23(decoder, index, builder instanceof UIntArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      v23(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.j1t(this.b1x_1, i);
            // Inline function 'kotlin.UInt.toInt' call
            var this_0 = UIntArray__get_impl_gp5kza(content, i);
            var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
            tmp.s1s(tmp$ret$0);
          }
           while (inductionVariable < size);
      }
      l1x(encoder, content, size) {
        return this.v23(encoder, content instanceof UIntArray() ? content.lv_1 : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'UIntArraySerializer', VOID, VOID, [KSerializer()]);
    UIntArraySerializerClass = $;
  }
  return UIntArraySerializerClass;
}
var UIntArraySerializer_instance;
function UIntArraySerializer_getInstance() {
  if (UIntArraySerializer_instance === VOID)
    new (UIntArraySerializer())();
  return UIntArraySerializer_instance;
}
var ShortArraySerializerClass;
function ShortArraySerializer() {
  if (ShortArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        ShortArraySerializer_instance = null;
        super(serializer_6(ShortCompanionObject_instance));
        ShortArraySerializer_instance = this;
      }
      y23(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      c1w(_this__u8e3s4) {
        return this.y23((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      z23(_this__u8e3s4, expectedSize) {
        if (expectedSize === _this__u8e3s4.length)
          return ShortArrayBuilder().c24(_this__u8e3s4);
        return ShortArrayBuilder().d24(copyOf_4(_this__u8e3s4, expectedSize), _this__u8e3s4.length);
      }
      b1v(_this__u8e3s4, expectedSize) {
        return this.z23((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE(), expectedSize);
      }
      j1x(size) {
        return ShortArrayBuilder().e24(size);
      }
      i1x() {
        return ShortArrayBuilder().f24();
      }
      g24(decoder, index, builder, checkIndex) {
        builder.h24(decoder.w1r(this.b1x_1, index));
      }
      k1v(decoder, index, builder, checkIndex) {
        return this.g24(decoder, index, builder instanceof ShortArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      k1x(decoder, index, builder, checkIndex) {
        return this.g24(decoder, index, builder instanceof ShortArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      i24(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.c1t(this.b1x_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      l1x(encoder, content, size) {
        return this.i24(encoder, (!(content == null) ? isShortArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'ShortArraySerializer', VOID, VOID, [KSerializer()]);
    ShortArraySerializerClass = $;
  }
  return ShortArraySerializerClass;
}
var ShortArraySerializer_instance;
function ShortArraySerializer_getInstance() {
  if (ShortArraySerializer_instance === VOID)
    new (ShortArraySerializer())();
  return ShortArraySerializer_instance;
}
var UShortArraySerializerClass;
function UShortArraySerializer() {
  if (UShortArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        UShortArraySerializer_instance = null;
        super(serializer_7(Companion_getInstance_2()));
        UShortArraySerializer_instance = this;
      }
      l24(_this__u8e3s4) {
        return _UShortArray___get_size__impl__jqto1b(_this__u8e3s4);
      }
      c1w(_this__u8e3s4) {
        return this.l24(_this__u8e3s4 instanceof UShortArray() ? _this__u8e3s4.hw_1 : THROW_CCE());
      }
      m24(_this__u8e3s4, expectedSize) {
        if (expectedSize === _UShortArray___get_size__impl__jqto1b(_this__u8e3s4))
          return UShortArrayBuilder().p24(_this__u8e3s4);
        // Inline function 'kotlin.collections.copyOf' call
        var tmp$ret$0 = _UShortArray___init__impl__9b26ef(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(_this__u8e3s4), expectedSize));
        return UShortArrayBuilder().q24(tmp$ret$0, _UShortArray___get_size__impl__jqto1b(_this__u8e3s4));
      }
      b1v(_this__u8e3s4, expectedSize) {
        return this.m24(_this__u8e3s4 instanceof UShortArray() ? _this__u8e3s4.hw_1 : THROW_CCE(), expectedSize);
      }
      j1x(size) {
        return UShortArrayBuilder().r24(size);
      }
      i1x() {
        return UShortArrayBuilder().s24();
      }
      t24(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toUShort' call
        var this_0 = decoder.d1s(this.b1x_1, index).h1r();
        var tmp$ret$0 = _UShort___init__impl__jigrne(this_0);
        builder.u24(tmp$ret$0);
      }
      k1v(decoder, index, builder, checkIndex) {
        return this.t24(decoder, index, builder instanceof UShortArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      k1x(decoder, index, builder, checkIndex) {
        return this.t24(decoder, index, builder instanceof UShortArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      v24(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.j1t(this.b1x_1, i);
            // Inline function 'kotlin.UShort.toShort' call
            var this_0 = UShortArray__get_impl_fnbhmx(content, i);
            var tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
            tmp.r1s(tmp$ret$0);
          }
           while (inductionVariable < size);
      }
      l1x(encoder, content, size) {
        return this.v24(encoder, content instanceof UShortArray() ? content.hw_1 : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'UShortArraySerializer', VOID, VOID, [KSerializer()]);
    UShortArraySerializerClass = $;
  }
  return UShortArraySerializerClass;
}
var UShortArraySerializer_instance;
function UShortArraySerializer_getInstance() {
  if (UShortArraySerializer_instance === VOID)
    new (UShortArraySerializer())();
  return UShortArraySerializer_instance;
}
var ByteArraySerializerClass;
function ByteArraySerializer() {
  if (ByteArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        ByteArraySerializer_instance = null;
        super(serializer_8(ByteCompanionObject_instance));
        ByteArraySerializer_instance = this;
      }
      y24(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      c1w(_this__u8e3s4) {
        return this.y24((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      z24(_this__u8e3s4, expectedSize) {
        if (expectedSize === _this__u8e3s4.length)
          return ByteArrayBuilder().c25(_this__u8e3s4);
        return ByteArrayBuilder().d25(copyOf_5(_this__u8e3s4, expectedSize), _this__u8e3s4.length);
      }
      b1v(_this__u8e3s4, expectedSize) {
        return this.z24((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE(), expectedSize);
      }
      j1x(size) {
        return ByteArrayBuilder().e25(size);
      }
      i1x() {
        return ByteArrayBuilder().f25();
      }
      g25(decoder, index, builder, checkIndex) {
        builder.h25(decoder.v1r(this.b1x_1, index));
      }
      k1v(decoder, index, builder, checkIndex) {
        return this.g25(decoder, index, builder instanceof ByteArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      k1x(decoder, index, builder, checkIndex) {
        return this.g25(decoder, index, builder instanceof ByteArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      i25(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.b1t(this.b1x_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      l1x(encoder, content, size) {
        return this.i25(encoder, (!(content == null) ? isByteArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'ByteArraySerializer', VOID, VOID, [KSerializer()]);
    ByteArraySerializerClass = $;
  }
  return ByteArraySerializerClass;
}
var ByteArraySerializer_instance;
function ByteArraySerializer_getInstance() {
  if (ByteArraySerializer_instance === VOID)
    new (ByteArraySerializer())();
  return ByteArraySerializer_instance;
}
var UByteArraySerializerClass;
function UByteArraySerializer() {
  if (UByteArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        UByteArraySerializer_instance = null;
        super(serializer_9(Companion_getInstance_3()));
        UByteArraySerializer_instance = this;
      }
      l25(_this__u8e3s4) {
        return _UByteArray___get_size__impl__h6pkdv(_this__u8e3s4);
      }
      c1w(_this__u8e3s4) {
        return this.l25(_this__u8e3s4 instanceof UByteArray() ? _this__u8e3s4.av_1 : THROW_CCE());
      }
      m25(_this__u8e3s4, expectedSize) {
        if (expectedSize === _UByteArray___get_size__impl__h6pkdv(_this__u8e3s4))
          return UByteArrayBuilder().p25(_this__u8e3s4);
        // Inline function 'kotlin.collections.copyOf' call
        var tmp$ret$0 = _UByteArray___init__impl__ip4y9n(copyOf_5(_UByteArray___get_storage__impl__d4kctt(_this__u8e3s4), expectedSize));
        return UByteArrayBuilder().q25(tmp$ret$0, _UByteArray___get_size__impl__h6pkdv(_this__u8e3s4));
      }
      b1v(_this__u8e3s4, expectedSize) {
        return this.m25(_this__u8e3s4 instanceof UByteArray() ? _this__u8e3s4.av_1 : THROW_CCE(), expectedSize);
      }
      j1x(size) {
        return UByteArrayBuilder().r25(size);
      }
      i1x() {
        return UByteArrayBuilder().s25();
      }
      t25(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toUByte' call
        var this_0 = decoder.d1s(this.b1x_1, index).g1r();
        var tmp$ret$0 = _UByte___init__impl__g9hnc4(this_0);
        builder.u25(tmp$ret$0);
      }
      k1v(decoder, index, builder, checkIndex) {
        return this.t25(decoder, index, builder instanceof UByteArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      k1x(decoder, index, builder, checkIndex) {
        return this.t25(decoder, index, builder instanceof UByteArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      v25(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.j1t(this.b1x_1, i);
            // Inline function 'kotlin.UByte.toByte' call
            var this_0 = UByteArray__get_impl_t5f3hv(content, i);
            var tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
            tmp.q1s(tmp$ret$0);
          }
           while (inductionVariable < size);
      }
      l1x(encoder, content, size) {
        return this.v25(encoder, content instanceof UByteArray() ? content.av_1 : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'UByteArraySerializer', VOID, VOID, [KSerializer()]);
    UByteArraySerializerClass = $;
  }
  return UByteArraySerializerClass;
}
var UByteArraySerializer_instance;
function UByteArraySerializer_getInstance() {
  if (UByteArraySerializer_instance === VOID)
    new (UByteArraySerializer())();
  return UByteArraySerializer_instance;
}
var BooleanArraySerializerClass;
function BooleanArraySerializer() {
  if (BooleanArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        BooleanArraySerializer_instance = null;
        super(serializer_10(BooleanCompanionObject_instance));
        BooleanArraySerializer_instance = this;
      }
      y25(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      c1w(_this__u8e3s4) {
        return this.y25((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      z25(_this__u8e3s4, expectedSize) {
        if (expectedSize === _this__u8e3s4.length)
          return BooleanArrayBuilder().c26(_this__u8e3s4);
        return BooleanArrayBuilder().d26(copyOf_6(_this__u8e3s4, expectedSize), _this__u8e3s4.length);
      }
      b1v(_this__u8e3s4, expectedSize) {
        return this.z25((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE(), expectedSize);
      }
      j1x(size) {
        return BooleanArrayBuilder().e26(size);
      }
      i1x() {
        return BooleanArrayBuilder().f26();
      }
      g26(decoder, index, builder, checkIndex) {
        builder.h26(decoder.u1r(this.b1x_1, index));
      }
      k1v(decoder, index, builder, checkIndex) {
        return this.g26(decoder, index, builder instanceof BooleanArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      k1x(decoder, index, builder, checkIndex) {
        return this.g26(decoder, index, builder instanceof BooleanArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      i26(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.a1t(this.b1x_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      l1x(encoder, content, size) {
        return this.i26(encoder, (!(content == null) ? isBooleanArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'BooleanArraySerializer', VOID, VOID, [KSerializer()]);
    BooleanArraySerializerClass = $;
  }
  return BooleanArraySerializerClass;
}
var BooleanArraySerializer_instance;
function BooleanArraySerializer_getInstance() {
  if (BooleanArraySerializer_instance === VOID)
    new (BooleanArraySerializer())();
  return BooleanArraySerializer_instance;
}
var CharArrayBuilderClass;
function CharArrayBuilder() {
  if (CharArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData, initialPosition) {
        return new.target.q20(bufferWithData, initialPosition);
      }
      static q20(bufferWithData, initialPosition) {
        var $this = this.n1x();
        $this.n20_1 = bufferWithData;
        $this.o20_1 = initialPosition;
        return $this;
      }
      static p20(bufferWithData) {
        return this.q20(bufferWithData, bufferWithData.length);
      }
      static r20(initialCapacity) {
        return this.q20(charArray(initialCapacity), 0);
      }
      static s20() {
        return this.q20(charArray(10), 0);
      }
      d1x() {
        return this.o20_1;
      }
      o1x(requiredCapacity) {
        if (this.n20_1.length < requiredCapacity)
          this.n20_1 = copyOf(this.n20_1, coerceAtLeast(requiredCapacity, imul(this.n20_1.length, 2)));
      }
      u20(c) {
        this.p1x();
        var tmp = this.n20_1;
        var _unary__edvuaz = this.o20_1;
        this.o20_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      f1x() {
        return copyOf(this.n20_1, this.o20_1);
      }
    }
    initMetadataForClass($, 'CharArrayBuilder');
    CharArrayBuilderClass = $;
  }
  return CharArrayBuilderClass;
}
var DoubleArrayBuilderClass;
function DoubleArrayBuilder() {
  if (DoubleArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData, initialPosition) {
        return new.target.d21(bufferWithData, initialPosition);
      }
      static d21(bufferWithData, initialPosition) {
        var $this = this.n1x();
        $this.a21_1 = bufferWithData;
        $this.b21_1 = initialPosition;
        return $this;
      }
      static c21(bufferWithData) {
        return this.d21(bufferWithData, bufferWithData.length);
      }
      static e21(initialCapacity) {
        return this.d21(new Float64Array(initialCapacity), 0);
      }
      static f21() {
        return this.d21(new Float64Array(10), 0);
      }
      d1x() {
        return this.b21_1;
      }
      o1x(requiredCapacity) {
        if (this.a21_1.length < requiredCapacity)
          this.a21_1 = copyOf_0(this.a21_1, coerceAtLeast(requiredCapacity, imul(this.a21_1.length, 2)));
      }
      h21(c) {
        this.p1x();
        var tmp = this.a21_1;
        var _unary__edvuaz = this.b21_1;
        this.b21_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      f1x() {
        return copyOf_0(this.a21_1, this.b21_1);
      }
    }
    initMetadataForClass($, 'DoubleArrayBuilder');
    DoubleArrayBuilderClass = $;
  }
  return DoubleArrayBuilderClass;
}
var FloatArrayBuilderClass;
function FloatArrayBuilder() {
  if (FloatArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData, initialPosition) {
        return new.target.q21(bufferWithData, initialPosition);
      }
      static q21(bufferWithData, initialPosition) {
        var $this = this.n1x();
        $this.n21_1 = bufferWithData;
        $this.o21_1 = initialPosition;
        return $this;
      }
      static p21(bufferWithData) {
        return this.q21(bufferWithData, bufferWithData.length);
      }
      static r21(initialCapacity) {
        return this.q21(new Float32Array(initialCapacity), 0);
      }
      static s21() {
        return this.q21(new Float32Array(10), 0);
      }
      d1x() {
        return this.o21_1;
      }
      o1x(requiredCapacity) {
        if (this.n21_1.length < requiredCapacity)
          this.n21_1 = copyOf_1(this.n21_1, coerceAtLeast(requiredCapacity, imul(this.n21_1.length, 2)));
      }
      u21(c) {
        this.p1x();
        var tmp = this.n21_1;
        var _unary__edvuaz = this.o21_1;
        this.o21_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      f1x() {
        return copyOf_1(this.n21_1, this.o21_1);
      }
    }
    initMetadataForClass($, 'FloatArrayBuilder');
    FloatArrayBuilderClass = $;
  }
  return FloatArrayBuilderClass;
}
var LongArrayBuilderClass;
function LongArrayBuilder() {
  if (LongArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData, initialPosition) {
        return new.target.d22(bufferWithData, initialPosition);
      }
      static d22(bufferWithData, initialPosition) {
        var $this = this.n1x();
        $this.a22_1 = bufferWithData;
        $this.b22_1 = initialPosition;
        return $this;
      }
      static c22(bufferWithData) {
        return this.d22(bufferWithData, bufferWithData.length);
      }
      static e22(initialCapacity) {
        return this.d22(new BigInt64Array(initialCapacity), 0);
      }
      static f22() {
        return this.d22(new BigInt64Array(10), 0);
      }
      d1x() {
        return this.b22_1;
      }
      o1x(requiredCapacity) {
        if (this.a22_1.length < requiredCapacity)
          this.a22_1 = copyOf_2(this.a22_1, coerceAtLeast(requiredCapacity, imul(this.a22_1.length, 2)));
      }
      h22(c) {
        this.p1x();
        var tmp = this.a22_1;
        var _unary__edvuaz = this.b22_1;
        this.b22_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      f1x() {
        return copyOf_2(this.a22_1, this.b22_1);
      }
    }
    initMetadataForClass($, 'LongArrayBuilder');
    LongArrayBuilderClass = $;
  }
  return LongArrayBuilderClass;
}
var ULongArrayBuilderClass;
function ULongArrayBuilder() {
  if (ULongArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData, initialPosition) {
        return new.target.q22(bufferWithData, initialPosition);
      }
      static q22(bufferWithData, initialPosition) {
        var $this = this.n1x();
        $this.n22_1 = bufferWithData;
        $this.o22_1 = initialPosition;
        return $this;
      }
      static p22(bufferWithData) {
        return this.q22(bufferWithData, _ULongArray___get_size__impl__ju6dtr(bufferWithData));
      }
      static r22(initialCapacity) {
        return this.q22(_ULongArray___init__impl__twm1l3_0(initialCapacity), 0);
      }
      static s22() {
        return this.q22(_ULongArray___init__impl__twm1l3_0(10), 0);
      }
      d1x() {
        return this.o22_1;
      }
      o1x(requiredCapacity) {
        if (_ULongArray___get_size__impl__ju6dtr(this.n22_1) < requiredCapacity) {
          var tmp = this;
          var tmp0 = this.n22_1;
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = coerceAtLeast(requiredCapacity, imul(_ULongArray___get_size__impl__ju6dtr(this.n22_1), 2));
          tmp.n22_1 = _ULongArray___init__impl__twm1l3(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
        }
      }
      u22(c) {
        this.p1x();
        var tmp = this.n22_1;
        var _unary__edvuaz = this.o22_1;
        this.o22_1 = _unary__edvuaz + 1 | 0;
        ULongArray__set_impl_z19mvh(tmp, _unary__edvuaz, c);
      }
      j26() {
        var tmp0 = this.n22_1;
        // Inline function 'kotlin.collections.copyOf' call
        var newSize = this.o22_1;
        return _ULongArray___init__impl__twm1l3(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
      }
      f1x() {
        return new (ULongArray())(this.j26());
      }
    }
    initMetadataForClass($, 'ULongArrayBuilder');
    ULongArrayBuilderClass = $;
  }
  return ULongArrayBuilderClass;
}
var IntArrayBuilderClass;
function IntArrayBuilder() {
  if (IntArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData, initialPosition) {
        return new.target.d23(bufferWithData, initialPosition);
      }
      static d23(bufferWithData, initialPosition) {
        var $this = this.n1x();
        $this.a23_1 = bufferWithData;
        $this.b23_1 = initialPosition;
        return $this;
      }
      static c23(bufferWithData) {
        return this.d23(bufferWithData, bufferWithData.length);
      }
      static e23(initialCapacity) {
        return this.d23(new Int32Array(initialCapacity), 0);
      }
      static f23() {
        return this.d23(new Int32Array(10), 0);
      }
      d1x() {
        return this.b23_1;
      }
      o1x(requiredCapacity) {
        if (this.a23_1.length < requiredCapacity)
          this.a23_1 = copyOf_3(this.a23_1, coerceAtLeast(requiredCapacity, imul(this.a23_1.length, 2)));
      }
      h23(c) {
        this.p1x();
        var tmp = this.a23_1;
        var _unary__edvuaz = this.b23_1;
        this.b23_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      f1x() {
        return copyOf_3(this.a23_1, this.b23_1);
      }
    }
    initMetadataForClass($, 'IntArrayBuilder');
    IntArrayBuilderClass = $;
  }
  return IntArrayBuilderClass;
}
var UIntArrayBuilderClass;
function UIntArrayBuilder() {
  if (UIntArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData, initialPosition) {
        return new.target.q23(bufferWithData, initialPosition);
      }
      static q23(bufferWithData, initialPosition) {
        var $this = this.n1x();
        $this.n23_1 = bufferWithData;
        $this.o23_1 = initialPosition;
        return $this;
      }
      static p23(bufferWithData) {
        return this.q23(bufferWithData, _UIntArray___get_size__impl__r6l8ci(bufferWithData));
      }
      static r23(initialCapacity) {
        return this.q23(_UIntArray___init__impl__ghjpc6_0(initialCapacity), 0);
      }
      static s23() {
        return this.q23(_UIntArray___init__impl__ghjpc6_0(10), 0);
      }
      d1x() {
        return this.o23_1;
      }
      o1x(requiredCapacity) {
        if (_UIntArray___get_size__impl__r6l8ci(this.n23_1) < requiredCapacity) {
          var tmp = this;
          var tmp0 = this.n23_1;
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = coerceAtLeast(requiredCapacity, imul(_UIntArray___get_size__impl__r6l8ci(this.n23_1), 2));
          tmp.n23_1 = _UIntArray___init__impl__ghjpc6(copyOf_3(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
        }
      }
      u23(c) {
        this.p1x();
        var tmp = this.n23_1;
        var _unary__edvuaz = this.o23_1;
        this.o23_1 = _unary__edvuaz + 1 | 0;
        UIntArray__set_impl_7f2zu2(tmp, _unary__edvuaz, c);
      }
      k26() {
        var tmp0 = this.n23_1;
        // Inline function 'kotlin.collections.copyOf' call
        var newSize = this.o23_1;
        return _UIntArray___init__impl__ghjpc6(copyOf_3(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
      }
      f1x() {
        return new (UIntArray())(this.k26());
      }
    }
    initMetadataForClass($, 'UIntArrayBuilder');
    UIntArrayBuilderClass = $;
  }
  return UIntArrayBuilderClass;
}
var ShortArrayBuilderClass;
function ShortArrayBuilder() {
  if (ShortArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData, initialPosition) {
        return new.target.d24(bufferWithData, initialPosition);
      }
      static d24(bufferWithData, initialPosition) {
        var $this = this.n1x();
        $this.a24_1 = bufferWithData;
        $this.b24_1 = initialPosition;
        return $this;
      }
      static c24(bufferWithData) {
        return this.d24(bufferWithData, bufferWithData.length);
      }
      static e24(initialCapacity) {
        return this.d24(new Int16Array(initialCapacity), 0);
      }
      static f24() {
        return this.d24(new Int16Array(10), 0);
      }
      d1x() {
        return this.b24_1;
      }
      o1x(requiredCapacity) {
        if (this.a24_1.length < requiredCapacity)
          this.a24_1 = copyOf_4(this.a24_1, coerceAtLeast(requiredCapacity, imul(this.a24_1.length, 2)));
      }
      h24(c) {
        this.p1x();
        var tmp = this.a24_1;
        var _unary__edvuaz = this.b24_1;
        this.b24_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      f1x() {
        return copyOf_4(this.a24_1, this.b24_1);
      }
    }
    initMetadataForClass($, 'ShortArrayBuilder');
    ShortArrayBuilderClass = $;
  }
  return ShortArrayBuilderClass;
}
var UShortArrayBuilderClass;
function UShortArrayBuilder() {
  if (UShortArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData, initialPosition) {
        return new.target.q24(bufferWithData, initialPosition);
      }
      static q24(bufferWithData, initialPosition) {
        var $this = this.n1x();
        $this.n24_1 = bufferWithData;
        $this.o24_1 = initialPosition;
        return $this;
      }
      static p24(bufferWithData) {
        return this.q24(bufferWithData, _UShortArray___get_size__impl__jqto1b(bufferWithData));
      }
      static r24(initialCapacity) {
        return this.q24(_UShortArray___init__impl__9b26ef_0(initialCapacity), 0);
      }
      static s24() {
        return this.q24(_UShortArray___init__impl__9b26ef_0(10), 0);
      }
      d1x() {
        return this.o24_1;
      }
      o1x(requiredCapacity) {
        if (_UShortArray___get_size__impl__jqto1b(this.n24_1) < requiredCapacity) {
          var tmp = this;
          var tmp0 = this.n24_1;
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = coerceAtLeast(requiredCapacity, imul(_UShortArray___get_size__impl__jqto1b(this.n24_1), 2));
          tmp.n24_1 = _UShortArray___init__impl__9b26ef(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
        }
      }
      u24(c) {
        this.p1x();
        var tmp = this.n24_1;
        var _unary__edvuaz = this.o24_1;
        this.o24_1 = _unary__edvuaz + 1 | 0;
        UShortArray__set_impl_6d8whp(tmp, _unary__edvuaz, c);
      }
      l26() {
        var tmp0 = this.n24_1;
        // Inline function 'kotlin.collections.copyOf' call
        var newSize = this.o24_1;
        return _UShortArray___init__impl__9b26ef(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
      }
      f1x() {
        return new (UShortArray())(this.l26());
      }
    }
    initMetadataForClass($, 'UShortArrayBuilder');
    UShortArrayBuilderClass = $;
  }
  return UShortArrayBuilderClass;
}
var ByteArrayBuilderClass;
function ByteArrayBuilder() {
  if (ByteArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData, initialPosition) {
        return new.target.d25(bufferWithData, initialPosition);
      }
      static d25(bufferWithData, initialPosition) {
        var $this = this.n1x();
        $this.a25_1 = bufferWithData;
        $this.b25_1 = initialPosition;
        return $this;
      }
      static c25(bufferWithData) {
        return this.d25(bufferWithData, bufferWithData.length);
      }
      static e25(initialCapacity) {
        return this.d25(new Int8Array(initialCapacity), 0);
      }
      static f25() {
        return this.d25(new Int8Array(10), 0);
      }
      d1x() {
        return this.b25_1;
      }
      o1x(requiredCapacity) {
        if (this.a25_1.length < requiredCapacity)
          this.a25_1 = copyOf_5(this.a25_1, coerceAtLeast(requiredCapacity, imul(this.a25_1.length, 2)));
      }
      h25(c) {
        this.p1x();
        var tmp = this.a25_1;
        var _unary__edvuaz = this.b25_1;
        this.b25_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      f1x() {
        return copyOf_5(this.a25_1, this.b25_1);
      }
    }
    initMetadataForClass($, 'ByteArrayBuilder');
    ByteArrayBuilderClass = $;
  }
  return ByteArrayBuilderClass;
}
var UByteArrayBuilderClass;
function UByteArrayBuilder() {
  if (UByteArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData, initialPosition) {
        return new.target.q25(bufferWithData, initialPosition);
      }
      static q25(bufferWithData, initialPosition) {
        var $this = this.n1x();
        $this.n25_1 = bufferWithData;
        $this.o25_1 = initialPosition;
        return $this;
      }
      static p25(bufferWithData) {
        return this.q25(bufferWithData, _UByteArray___get_size__impl__h6pkdv(bufferWithData));
      }
      static r25(initialCapacity) {
        return this.q25(_UByteArray___init__impl__ip4y9n_0(initialCapacity), 0);
      }
      static s25() {
        return this.q25(_UByteArray___init__impl__ip4y9n_0(10), 0);
      }
      d1x() {
        return this.o25_1;
      }
      o1x(requiredCapacity) {
        if (_UByteArray___get_size__impl__h6pkdv(this.n25_1) < requiredCapacity) {
          var tmp = this;
          var tmp0 = this.n25_1;
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = coerceAtLeast(requiredCapacity, imul(_UByteArray___get_size__impl__h6pkdv(this.n25_1), 2));
          tmp.n25_1 = _UByteArray___init__impl__ip4y9n(copyOf_5(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
        }
      }
      u25(c) {
        this.p1x();
        var tmp = this.n25_1;
        var _unary__edvuaz = this.o25_1;
        this.o25_1 = _unary__edvuaz + 1 | 0;
        UByteArray__set_impl_jvcicn(tmp, _unary__edvuaz, c);
      }
      m26() {
        var tmp0 = this.n25_1;
        // Inline function 'kotlin.collections.copyOf' call
        var newSize = this.o25_1;
        return _UByteArray___init__impl__ip4y9n(copyOf_5(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
      }
      f1x() {
        return new (UByteArray())(this.m26());
      }
    }
    initMetadataForClass($, 'UByteArrayBuilder');
    UByteArrayBuilderClass = $;
  }
  return UByteArrayBuilderClass;
}
var BooleanArrayBuilderClass;
function BooleanArrayBuilder() {
  if (BooleanArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData, initialPosition) {
        return new.target.d26(bufferWithData, initialPosition);
      }
      static d26(bufferWithData, initialPosition) {
        var $this = this.n1x();
        $this.a26_1 = bufferWithData;
        $this.b26_1 = initialPosition;
        return $this;
      }
      static c26(bufferWithData) {
        return this.d26(bufferWithData, bufferWithData.length);
      }
      static e26(initialCapacity) {
        return this.d26(booleanArray(initialCapacity), 0);
      }
      static f26() {
        return this.d26(booleanArray(10), 0);
      }
      d1x() {
        return this.b26_1;
      }
      o1x(requiredCapacity) {
        if (this.a26_1.length < requiredCapacity)
          this.a26_1 = copyOf_6(this.a26_1, coerceAtLeast(requiredCapacity, imul(this.a26_1.length, 2)));
      }
      h26(c) {
        this.p1x();
        var tmp = this.a26_1;
        var _unary__edvuaz = this.b26_1;
        this.b26_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      f1x() {
        return copyOf_6(this.a26_1, this.b26_1);
      }
    }
    initMetadataForClass($, 'BooleanArrayBuilder');
    BooleanArrayBuilderClass = $;
  }
  return BooleanArrayBuilderClass;
}
//region block: exports
export {
  BooleanArraySerializer_getInstance as BooleanArraySerializer_getInstance1u7esswhuhgdo,
  ByteArraySerializer_getInstance as ByteArraySerializer_getInstance2fuv9a137bvc4,
  CharArraySerializer_getInstance as CharArraySerializer_getInstance2mu447sxrz0td,
  DoubleArraySerializer_getInstance as DoubleArraySerializer_getInstance14oy86gxun29t,
  FloatArraySerializer_getInstance as FloatArraySerializer_getInstancexaku2izexxhx,
  IntArraySerializer_getInstance as IntArraySerializer_getInstanceqou69s68jhpv,
  LongArraySerializer_getInstance as LongArraySerializer_getInstance3jvz8bkl0kqnj,
  ShortArraySerializer_getInstance as ShortArraySerializer_getInstance1401rzbbbe6ma,
  UByteArraySerializer_getInstance as UByteArraySerializer_getInstance1d8h5wo399t1t,
  UIntArraySerializer_getInstance as UIntArraySerializer_getInstancec7tztknra5r3,
  ULongArraySerializer_getInstance as ULongArraySerializer_getInstancehm7rd2yih7u8,
  UShortArraySerializer_getInstance as UShortArraySerializer_getInstance3lvdig2cpj19w,
};
//endregion

//# sourceMappingURL=PrimitiveArraysSerializers.mjs.map
